import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { Form, Spinner, Button } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { CancelIcon, CalendarIcon } from '@enterprise-ui/icons';
import React from 'react';

var _excluded = ["changeEvent", "data-testid", "disabled", "disableDates", "error", "errorText", "hintText", "highlight", "id", "isLoading", "label", "placeholder", "required", "selectDate", "selectedDate", "setIsCalendarVisible", "onClear"];
function RawInputField(_ref) {
  _ref.changeEvent;
    var dataTestId = _ref['data-testid'],
    disabled = _ref.disabled;
    _ref.disableDates;
    var error = _ref.error,
    errorText = _ref.errorText,
    hintText = _ref.hintText,
    highlight = _ref.highlight,
    id = _ref.id,
    isLoading = _ref.isLoading,
    label = _ref.label,
    placeholder = _ref.placeholder,
    required = _ref.required;
    _ref.selectDate;
    var selectedDate = _ref.selectedDate,
    setIsCalendarVisible = _ref.setIsCalendarVisible,
    onClear = _ref.onClear,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var date = selectedDate ? selectedDate : '';
  var handleOnClear = function handleOnClear() {
    onClear();
    setIsCalendarVisible(true);
  };
  var iconAreaContent = function iconAreaContent() {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(Spinner, {
        size: "dense"
      });
    } else if (date && date.format) {
      return /*#__PURE__*/React.createElement(Button, {
        iconOnly: true,
        size: "dense",
        className: "C-DatePicker__NavButton --embeddedInComponent",
        disabled: disabled,
        "data-testid": dataTestId && "".concat(dataTestId, "_clearInput"),
        "data-test": "calendarButton",
        "aria-label": "clear input",
        onClick: handleOnClear
      }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
        icon: CancelIcon,
        size: 'inline'
      }));
    } else {
      return /*#__PURE__*/React.createElement(Button, {
        iconOnly: true,
        size: "dense",
        className: "C-DatePicker__NavButton --embeddedInComponent",
        disabled: disabled,
        "data-testid": dataTestId && "".concat(dataTestId, "_openCalendar"),
        "data-test": "clearButton",
        "aria-label": "open calendar",
        onClick: function onClick() {
          return setIsCalendarVisible(true);
        }
      }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
        icon: CalendarIcon,
        size: 'inline'
      }));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "C-DatePicker__Input"
  }, /*#__PURE__*/React.createElement(Form.Field, _extends({}, otherProps, {
    disabled: disabled,
    error: error,
    errorText: errorText,
    highlight: highlight,
    id: id,
    label: label,
    placeholder: placeholder,
    onFocus: function onFocus() {
      return setIsCalendarVisible(true);
    },
    required: required,
    value: date ? date.format : '',
    hintText: hintText,
    "data-testid": dataTestId ? "".concat(dataTestId, "_formfield") : null
  })), /*#__PURE__*/React.createElement("span", {
    className: "C-DatePicker__MonthIcons"
  }, iconAreaContent()));
}
RawInputField.displayName = 'InputField';
var InputField = /*#__PURE__*/React.memo(RawInputField);

export { InputField as default };
